import { render, staticRenderFns } from "./EditScheduledOcr.vue?vue&type=template&id=50675bdb&scoped=true&"
import script from "./EditScheduledOcr.vue?vue&type=script&lang=js&"
export * from "./EditScheduledOcr.vue?vue&type=script&lang=js&"
import style0 from "./EditScheduledOcr.vue?vue&type=style&index=0&id=50675bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50675bdb",
  null
  
)

export default component.exports